const Health = () => {
    return (<h3 className="mt-5">Hey There!!! The App is Healthy</h3>);
};
export default Health;